import { memo } from 'react';
import { DataTableSkeleton } from '../components/DataTable';
import { SESSIONS_COLUMNS, SESSIONS_TABLE_MIN_WIDTH } from './SessionsTable';

export const SessionsTableSkeleton = memo(function SessionsTableSkeleton() {
  return <DataTableSkeleton columns={SESSIONS_COLUMNS} rows={5} minWidth={SESSIONS_TABLE_MIN_WIDTH} dense />;
});

export default SessionsTableSkeleton;
